// removed by extract-text-webpack-plugin
module.exports = {"test":"test_3lrU8","spin":"spin_VGFQF"};


//////////////////
// WEBPACK FOOTER
// ./containers/App/style.css
// module id = 409
// module chunks = 0